/**
 * @module sanitize
 * @since 2.22.0
 */

import xss from 'xss';
import { SanitizationGroup } from '../SanitizationGroup';
import { BLACKLISTED_ATTRIBUTES, SANITIZATION_GROUP_TAGS_MAPPING } from './constants';

/**
 * Interpolate  element attributes.
 * @param  {String} tag The current element being parsed.
 * @param  {String} name The current attribute being parsed.
 * @param  {String} value The current attribute's value.
 * @return {String?}
 * @see https://github.com/leizongmin/js-xss#customize-the-handler-function-for-attributes-not-in-the-whitelist
 */
function onIgnoreTagAttr(tag, name, value) {
    if (BLACKLISTED_ATTRIBUTES.has(name)) { return; }

    return `${name}="${value}"`;
}

/**
 * A mapping of the supported tags in a structure expected by the "xss" package.
 * @param {String} [sanitizationGroup] Tags sanitization group.
 * @type {Object}
 */
const getWhiteListMap = (sanitizationGroup) => {
    const sanitizationTags = SANITIZATION_GROUP_TAGS_MAPPING[sanitizationGroup];

    if (!sanitizationTags) {
        throw new Error(`The sanitization group does not match one of the accept groups: ${Object.keys(SANITIZATION_GROUP_TAGS_MAPPING).join(',')}`);
    }

    return sanitizationTags.reduce(
        (accumulator, tag) => Object.assign(
            accumulator,
            { [tag]: [] }
        ),
        {}
    );
};

/**
 * Does a basic sanitization of a string and allows only certain tags to be parsed out.
 * @param {String} [string] String to be sanitized.
 * @param {String} [sanitizationGroup] Tags group.
 * @return {String} Sanitized markup.
 */
export const sanitize = (string = '', sanitizationGroup = SanitizationGroup.HTML) => xss(string, {
    whiteList: getWhiteListMap(sanitizationGroup),
    onIgnoreTagAttr
});
